<template>
  <span class="NameWithEmoji"><template
    v-for="(part, i) in parts"
    :key="i"
  ><img
    v-if="part.type === 'emoji' && !failed.has(i)"
    class="emoji"
    :src="part.src"
    :alt="part.alt"
    :title="part.alt"
    @error="failed = new Set(failed).add(i)"
  ><template v-else-if="part.type === 'emoji'" /><UnicodeEmoji
    v-else-if="part.type === 'unicode'"
    :emoji="part.text"
  /><template v-else>{{ part.text }}</template></template></span>
</template>

<script>
import UnicodeEmoji from 'src/components/unicode_emoji/unicode_emoji.vue'

import { nameParts } from 'src/services/rich_text/rich_text.js'
import { processTextForUnicodeEmoji } from 'src/services/unicode_emoji/unicode_emoji.js'

// A display name as text, with its custom emoji as pictures, and its
// unicode emoji as Twemoji when the user asked for pictures (UnicodeEmoji
// follows that setting).
export default {
  components: { UnicodeEmoji },
  // custom emoji that failed to load are left out: the broken picture
  // and its long alt text do not fit a name
  data: () => ({ failed: new Set() }),
  props: {
    name: { type: String, default: '' },
    // the user's emoji: [{ shortcode, url }]
    emoji: { type: Array, default: () => [] },
  },
  watch: {
    name() {
      this.failed = new Set()
    },
  },
  computed: {
    parts() {
      return nameParts(this.name, this.emoji).flatMap((part) =>
        part.type === 'text'
          ? processTextForUnicodeEmoji(part.text, (text) => ({
              type: 'unicode',
              text,
            })).map((p) =>
              typeof p === 'string' ? { type: 'text', text: p } : p,
            )
          : [part],
      )
    },
  },
}
</script>

<style lang="scss">
.NameWithEmoji .emoji {
  height: 1.2em;
  width: auto;
  max-width: 3em;
  vertical-align: -0.25em;
  object-fit: contain;
}
</style>
